



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { authModule } from '@/store';
import LoginForm from '@/components/auth/LoginForm.vue';
import RegisterForm from '@/components/auth/RegisterForm.vue';

@Component({
  components: { LoginForm, RegisterForm },
})
export default class extends Vue {
  loginTabs: number = 0;

  mounted() {
    if (authModule.isLoggedIn) {
      this.$router.push({ name: 'home' });
    }
  }
}
